import { IconPointFilled } from '@tabler/icons-react'
import React from 'react'

export const DealStatuaStats = () => {
    return (
        <div>
            <div className="card px-2">
                <div className="addEnquiryHead " style={{ fontWeight: 600, paddingLeft: "2rem" }}>Deals Status</div>
                <hr className='mb-0' />
                <div className="crm-card-body pb-2">
                    <div className="mb-3">
                        <span className="badge bg-success-transparent">
                            0
                            <i className="ri-arrow-up-s-fill align-mmiddle ms-1"></i>
                        </span>
                        <span className="mb-0 ms-2" style={{ fontWeight: 400, fontSize: '14px', }}>
                            Compared to last week
                        </span>
                    </div>

                    {/* progress bars */}
                    <div className="crm-progress-stacked crm-progress-animate crm-progress-xs mb-4">
                        <div
                            className="crm-progress-bar"
                            role="progressbar"
                            style={{ width: "21%", backgroundColor: "#0b6ffd" }}
                        ></div>
                        <div
                            className="crm-progress-bar"
                            role="progressbar"
                            style={{ width: "26%", backgroundColor: "#14c9ef" }}
                        ></div>
                        <div
                            className="crm-progress-bar"
                            role="progressbar"
                            style={{ width: "35%", backgroundColor: "#ffc207" }}
                        ></div>
                        <div
                            className="crm-progress-bar"
                            role="progressbar"
                            style={{ width: "18%", backgroundColor: "#1a8755" }}
                        ></div>
                    </div>

                    {/* number stats */}
                    <ul className="list-unstyled mb-0 pt-2">
                        <li className="mb-3 d-flex align-items-center justify-content-between">
                            <span className="mb-0" style={{ fontWeight: 400, fontSize: '14px', }}>
                                <IconPointFilled size={18} color='#0b6ffd' className='me-1' />
                                Pending Deals
                            </span>
                            <div className="fs-12 text-muted">
                                0 deals
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-center justify-content-between">
                            <span className="mb-0" style={{ fontWeight: 400, fontSize: '14px', }}>
                                <IconPointFilled size={18} color='#14c9ef' className='me-1' />
                                Rejected Deals
                            </span>

                            <div className="fs-12 text-muted">
                                0 deals
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-center justify-content-between">

                            <span className="mb-0" style={{ fontWeight: 400, fontSize: '14px', }}>
                                <IconPointFilled size={18} color='#ffc207' className='me-1' />
                                Upcoming Deals
                            </span>

                            <div className="fs-12 text-muted">
                                0 deals
                            </div>
                        </li>
                        <li className="mb-0 d-flex align-items-center justify-content-between">

                            <span className="mb-0" style={{ fontWeight: 400, fontSize: '14px', }}>
                                <IconPointFilled size={18} color='#1a8755' className='me-1' />
                                Upcoming Deals
                            </span>

                            <div className="fs-12 text-muted">
                                0 deals
                            </div>
                        </li>
                    </ul>
                </div >
            </div >
        </div >

    )
}
